import request from '../../api/request';
import { FormDataResponse, FormDataSubmit } from './types';

export const SECTIONS_REGISTRATION_MASSIVE = {
  FORM_DATA: '/maintainers-portal/subject-sections/registration-massive/form',
  BASE_INFO:
    '/maintainers-portal/subject-sections/registration-massive/base-info',
  TEMPLATE:
    '/maintainers-portal/subject-sections/registration-massive/template',
  UPLOAD_TEMPLATE:
    '/maintainers-portal/subject-sections/registration-massive/process',
  GET_FILE_UPLOAD_FAILURE: (fileUploadFailureId: string) =>
    `/maintainers-portal/subject-sections/registration-massive/file-upload-failure/${fileUploadFailureId}`,
};

export function getSectionsRegistrationMassiveData() {
  return request<FormDataResponse>(SECTIONS_REGISTRATION_MASSIVE.FORM_DATA);
}

export function getTemplate(formData: FormDataSubmit) {
  return request<Blob>(SECTIONS_REGISTRATION_MASSIVE.TEMPLATE, {
    data: formData,
    method: 'POST',
    responseType: 'blob',
  });
}

export function getBaseInfo(formData: FormDataSubmit) {
  return request<Blob>(SECTIONS_REGISTRATION_MASSIVE.BASE_INFO, {
    data: formData,
    method: 'POST',
    responseType: 'blob',
  });
}

export function uploadTemplate(file: File) {
  const url = SECTIONS_REGISTRATION_MASSIVE.UPLOAD_TEMPLATE;
  const data = new FormData();
  data.append('file', file);
  return request<any>(url, { data, method: 'POST' });
}

export function getFileUploadFailure(fileUploadFailureId: string) {
  return request<any>(
    SECTIONS_REGISTRATION_MASSIVE.GET_FILE_UPLOAD_FAILURE(fileUploadFailureId),
    { responseType: 'blob' },
  );
}
